import { Component, OnInit,ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-commission-markets",
  templateUrl: "./commission-markets.component.html",
  styleUrls: ["./commission-markets.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CommissionMarketsComponent implements OnInit {
  providersList:any;
  selectedProvider:string;
  sportsList:any;
  sportId:string='';
  startDate:any;
  endDate:any;
  competitionsList:any;
  competitionsHeaderList: string[] = [
    "Competition Name",
    "Competition Id",
    "Status",
    "Modified By",
    "Modified Date",
  ];
  constructor(private appService: AppService, private router: Router) {}

  ngOnInit() {
    this.getProviders()
    this.startDate=moment().startOf('day')
    this.endDate=moment().add(7,'day').endOf('day')
  }

  getProviders(){
    try{
      this.appService.getProviders().subscribe((res)=>{
        this.providersList=res.providers
      })
    }catch(err){
      console.log(err)
    }
  }

  onSelectedProviderId(providerID){
    this.selectedProvider=providerID
    this.getSportsByProvider()
  }

  getSportsByProvider(){
    try{
      this.appService.getSportData(this.selectedProvider).subscribe((res)=>{
        this.sportsList=res.sports
      })
    }catch(err){
      console.log(err)
    }
  }

  onSelectedSportName(sportId:string){
    this.sportId = sportId
    console.log("You have selected some sport!!!")
    this.getCompetitions()
  }

  getCompetitions(){
    console.log("We are doing the api call")
    console.log("StartDate",this.startDate,"toDate",this.endDate)
    try{
      this.appService.getCatalogCompetitions(this.selectedProvider,this.sportId,this.startDate,this.endDate,1,300).subscribe((res)=>{
        this.competitionsList=res.competitions
      })
    } catch(err){
      console.log(err)
    }
  }

  getBetPlaceDate(date: number) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }

  // Go to event level page
  goto(competitionId,competitionName){
    this.router.navigate([`administration/commission-markets/${this.selectedProvider}/${this.sportId}/${competitionId}`],{
      queryParams:{
        providerId:this.selectedProvider,
        competitionName:competitionName
      }
    })
  }
}
